<template>
  <transition name="fade">
    <box v-show="show" style="width:60vw;height: 60vh">
      <template v-slot:body>
        <action
          action-class="yellow"
          text="skip"
          class="icon-tree"
          @goNext="$router.push('final')"
        >
          <template v-slot:icon>
            <font-awesome-icon :icon="['fas', 'caret-right']" size="lg" />
          </template>
        </action>
        <div style="overflow: hidden">
          <div class="marquee">
            <p>傍晚。台北火車站大門前。小林。</p>
            <p>一輛計程車開到滿是人群的台北火車站前停下，車門打開，</p>
            <p>小林急下車，急急跑進車站。</p>
            <br />
            <p>傍晚。台北火車站內。小林，小林他爹，旅客。</p>
            <p>車站裡面萬頭鑽動，一片喧嘩。</p>
            <p>小林在人群裡擠來擠去地尋找他爹，頭上臉上都是汗水，</p>
            <p>背上的衣服也濕了一大塊。</p>
            <p>找啊找，到處找，終於在候車室牆角的地方找到了他爹。</p>
            <p>
              他爹靠在木條椅背上打盹，粗布包袱放在腿上，兩手交叉地壓著包袱。
            </p>
            <p>
              小林走上來，興奮與愧疚，憐憫與怨嘆統堆到臉上來。他伸手輕拍了拍他爹底肩膀。
            </p>
            <p>林（深情萬斛）：阿爸！</p>
            <br />
            <p>小林他爹沒有反應，是睡著了！</p>
            <p>小林再輕拍他爹的肩頭。</p>
            <p>他爹睜開惺忪的的睡眼，茫然環顧了一下，又閉上了。</p>
            <p>
              等小林要再拍他的底肩，他又張開眼睛，這回看清楚是小林，眼兒猛地一亮，忙把小林拉到身邊。
            </p>
            <br />
            <p>爹：（一臉慈祥的笑）小林仔，是你！</p>
            <p>自頭至腳仔細打量小林。</p>
            <p>爹：（台）你還是很瘦啊！要多吃飯啊！</p>
            <p>林：（台）阿爸，我今天公司足無閒（非常忙），卡（所以）──</p>
            <p>他爹擺一擺手，打斷小林底話。</p>
            <p>
              爹：阿爸知道一定是公事忙，你才沒來車頭（車站）接。吃人飯，患人問，阿爸在車頭多等一會，有什麼關係！
            </p>
            <p>他爹臉上都是慈祥底笑，一點埋怨也無，一點責怪之意也沒有。</p>
            <p>
              不敢正視他父親，小林趕緊頭轉到一邊去，眼眶都紅了，要不是候車室人多，他一定會放聲哭的。
            </p>
            <br />
            <p>
              晚上七、八點。小巷內簡陋小吃店。小林，小林他爹，小吃店老闆，小弟，幾位客人。
            </p>
            <br />
            <p>在簡陋的小吃店裡，小林和他爹坐在頭頂上裝有風扇的位子。</p>
            <p>
              老闆端來幾小碟小菜：滷蛋、海帶、花生米、涼拌筍片……。小弟捧上兩碗米粉。
            </p>
            <br />
            <p>
              爹：（問小林說）我不大餓，米粉吃一碗就可以，叫那麼多菜，莫裁錢呢！（浪費呀！）
            </p>
            <p>
              小林笑笑給他爹夾菜，然後跑到店前，跟老闆要了紅露酒加保力達，端到他爹面前。
            </p>
            <p>
              爹：甲尼樣（這麼樣）浪費做什麼呀！阿爸今嗎莫飲酒（現在也不喝酒了）不過他還是端起杯子啜飲一口，臉上立即出現好喜歡的神色。
            </p>
            <p>爹：這酒真香。</p>
            <p>
              林：阿爸，台北你們莫來過（台北你也沒來過），多玩幾天，我帶你四架（四處）走走。
            </p>
            <p>
              爹：我今晚就得回去。你二兄不知道我來台北找你。（呷一口酒）等沒有你的消息（回信），我想大概叫人代寫的信，忘記講：你二兄需要你幫忙兩萬元的代誌（事情），阿爸才趕來台北，當面講給你聽，較清楚。
            </p>
            <p>感到好愧咎難過，小林一口米粉吞了好久才吞下去。</p>
            <p>林：阿爸──</p>
            <p>他欲言又止。</p>
            <p>爹：嗯？</p>
            <p>林：這代誌（事情）信裡面有寫。</p>
            <p>爹：哦！</p>
            <p>
              小林他爹看了看小林，臉上的表情友詢問，有彷彿已經明白了一切等待的複雜表情。
            </p>
          </div>
        </div>
      </template>
    </box>
  </transition>
</template>
<script>
import Action from "@/components/Action.vue";
import Box from "@/components/Box.vue";

export default {
  components: { Action, Box },
  data() {
    return { show: false };
  },
  mounted() {
    this.$store.dispatch("clearUsername");
    setTimeout(() => {
      this.show = true;
    }, 300);
  }
};
</script>
<style lang="scss" scoped>
.marquee {
  top: 6em;
  color: #965151;
  font-weight: 600;
  position: relative;
  font-size: 18px;
  box-sizing: border-box;
  animation: marquee 30s linear infinite;
}

.marquee:hover {
  animation-play-state: paused;
}

/* Make it move! */
@keyframes marquee {
  0% {
    top: 8em;
  }
  100% {
    top: -11em;
  }
}

.icon-tree {
  position: absolute;
  bottom: -4em;
  right: -10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>